import styles from './styles.module.scss';

const Justified = ({ children }: { children?: React.ReactNode }) => (
  <div className={styles.root}>
    <div className={styles.contents}>{children}</div>
  </div>
);

export default Justified;
